import { useEffect } from 'react';
import Portfolio from '../Portfolios/Entities/Portfolio';

/**
 * Preloads all images in a portfolio for faster transitions
 */
// eslint-disable-next-line no-unused-vars
export function usePreloadImages(portfolio: Portfolio | undefined) {
    useEffect(() => {
        if (!portfolio) return;

        // Create image elements and trigger loading
        portfolio.pieces.forEach(piece => {
            const img = new Image();
            img.src = `/images/${piece.image}`;
            // Image loading happens in the background
        });
    }, [portfolio]);
}

